//@ts-ignore
//@ts-nocheck
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Dialog, Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useFormik } from "formik";
import { Fragment, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  registerRequest,
  registerService,
  validateTokenService,
} from "../../api/Register-solo";
import {
  default as MarkLogo,
  default as MarkLogoWhite,
} from "../../assets/images/MarkLogo.png";
import CheckRender from "../../components/CheckRender/CheckRender";
import DuplicateDocumentModal from "../../components/DuplicateDocumentModal";
import MaskTextField from "../../components/MaskTextField/MaskTextField";
import RadioButtonGroup from "../../components/RadioButtonGroup";
import Select from "../../components/Select/Select";
import TextField from "../../components/TextField/TextField";
import { RootState } from "../../stores/AppReducers";
import GlobalLoadingActions from "../../stores/GlobalLoading/Actions";
import COLORS from "../../theme/Colors";
import { StyledButton } from "../../theme/Styles";
import { isStringRepeated } from "../../utilities/StringUtil";
import { FormSchema, TRegisterBody } from "./Register-solo-Constants";
import {
  Container,
  FormContainer,
  LeftContainer,
  LogoImg,
  LogoModal,
  RightContainer,
  SuccessBody,
  SuccessMessage,
  SuccessTitle,
} from "./styles/Register-solo-Styles";
import CheckBox from "../../components/CheckBox";

function RegisterSolo(props: ScreenProps) {
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [formSuccess, setFormSuccess] = useState(false);
  const [formAvailable, setFormAvailable] = useState();
  const [showDuplicateDocumentModal, setShowDuplicateDocumentModal] =
    useState<boolean>(false);
  const [proamData, setProamData] = useState({
    blockProam: false,
    proamCourtesy: false,
  });
  const formik = useFormik({
    initialValues: {
      sponsoredPlayers: "0",
      sponsor: "",
      playerOneProam: proamData.blockProam ?? false,
      name: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      mobileNumber: "",
      company: "",
      documentType: 1,
      documentNumber: "",
      sex: 1,
      tshirtSize: 1,
      ghin: undefined,
      handicap: undefined,
      diestro: 1,
      gloveSize: 1,
      guest: "0",
      guestName: "",
      guestLastName: "",
      guestDocumentType: 1,
      guestDocument: "",
      guestEmail: "",
    },
    validationSchema: FormSchema,
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    onSubmit: (values, actions) => {
      handleRegister(values);
    },
  });

  //TO DO create data interface and use instead of any
  const handleRegister = async (data: TRegisterBody) => {
    try {
      const request: registerRequest = {
        token: searchParams.get("token") || "",
        name: data.name,
        proam: data.playerOneProam ? 1 : 0,
        lastname: data.lastname,
        email: data.email,
        phone_number: data.phoneNumber,
        mobile_number: data.mobileNumber,
        company: data.company,
        document_type: data.documentType,
        document_number: data.documentNumber,
        sex: data.sex,
        tshirt_size: data.tshirtSize,
        ghin: data.ghin,
        handicap: data.handicap,
        diestro: data.diestro,
        glove_size: data.gloveSize,
        include_guest: data.guest == "1" ? true : false,
        guest_name: data.guestName,
        guest_lastname: data.guestLastName,
        guest_document_type: data.guestDocumentType,
        guest_document: data.guestDocument,
        guest_email: data.guestEmail,
      };
      if (formAvailable) {
        const response = await registerService(request);
        if (response.ok) {
          //  navigate("/");
          setFormSuccess(true);
          // formik.resetForm();
          toast.success("Registro completado satisfactoriamente");
        }
        if (response.ok === false && response.msg.includes("Duplicate entry")) {
          setShowDuplicateDocumentModal(true);
        }
      }
    } catch (error) {
      if (
        error?.response?.data?.ok === false &&
        error?.response?.data?.error?.includes("Duplicate entry")
      ) {
        setShowDuplicateDocumentModal(true);
      } else {
        toast.error("Ha sucedido un error");
      }
    }
  };

  const validateToken = async (token: string) => {
    try {
      const response = await validateTokenService(token);
      if (response.ok) {
        setProamData({
          blockProam: response.proam,
          proamCourtesy: response?.proam_courtesy ?? false,
        });
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  /* validate if user can see the form */
  useEffect(() => {
    const token = searchParams.get("token");
    (async () => {
      if (token !== undefined) {
        /* validate token state */
        const result = await validateToken(token);
        if (result) {
          setFormAvailable(true);
        } else {
          setFormAvailable(false);
        }
      }
    })();
  }, []);
  useEffect(() => {
    const documents = [
      formik.values.documentNumber,
      formik.values.guestDocument,
    ];
    if (isStringRepeated(documents)) {
      setShowDuplicateDocumentModal(true);
    }
  }, [formik.errors]);

  return (
    <Container>
      <LeftContainer>
        <LogoImg src={MarkLogoWhite} />
      </LeftContainer>
      <RightContainer>
        <FormContainer>
          <Dialog open={formSuccess}>
            <IconButton
              sx={{ alignSelf: "flex-end", padding: "16px" }}
              aria-label="close"
              onClick={() =>
                navigate(`/payment?document=${formik.values.documentNumber}`)
              }
            >
              <CloseIcon sx={{ color: COLORS.primary }} />
            </IconButton>
            <div
              style={{
                justifyContent: "center",
                padding: "32px",
                paddingTop: 0,
                textAlign: "center",
              }}
            >
              <LogoModal style={{ maxWidth: "300px" }} src={MarkLogo} />
              <SuccessTitle>
                Su formulario ha sido llenado exitosamente.{" "}
              </SuccessTitle>
              <SuccessMessage>
                Su registro en el 3er Torneo de Golf Fundación iQtek está sujeto
                a confirmación. Manténgase atento a su correo electrónico, donde
                recibirá la confirmación en los próximos días.
              </SuccessMessage>
              <SuccessBody>
                ¡Gracias por su interés en formar parte de esta extraordinaria
                experiencia!
              </SuccessBody>
            </div>
          </Dialog>
          {/* Sold Out Dialog Modal */}
          {/*  <SoldOutModal setState={setFormAvailable} /> */}

          {/* Duplicate Document Dialog Modal */}
          <DuplicateDocumentModal
            showDialogModal={showDuplicateDocumentModal}
            setShowDialogModal={setShowDuplicateDocumentModal}
          />

          <CheckRender allowed={formAvailable === undefined}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                minHeight: "500px",
                height: "100vh",
              }}
            >
              <CircularProgress size={100} />
            </div>
          </CheckRender>

          <CheckRender allowed={formAvailable === false}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                minHeight: "500px",
                height: "100vh",
              }}
            >
              <h1>Su Token ha expirado o su registro ya ha sido utlizado</h1>
            </div>
          </CheckRender>

          <CheckRender allowed={formAvailable}>
            <h1>Registro de jugador</h1>
            <p>
              Introduce la información solicitada para completar el registro.
            </p>
            <br />
            <Grid
              alignItems="center"
              container
              direction="row"
              justifyContent={"flex-start"}
              spacing={{ xs: 1, md: 1.5 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Fragment>
                <Grid item xs={12} sm={12} md={12}>
                  <h3>Jugador</h3>
                </Grid>

                {proamData.blockProam === true && (
                  <Grid item xs={12} sm={12} md={12}>
                    <CheckBox
                      id="playerOneProam"
                      title="Inscribirme en el Pro-Am"
                      value={formik.values.playerOneProam}
                      onChange={formik.handleChange}
                      disabled={proamData.blockProam}
                    />
                    {formik.values.playerOneProam &&
                    !proamData.proamCourtesy ? (
                      <p>
                        <li>
                          El PROAM tiene un costo adicional de US$ 500.00.
                        </li>
                        <br />
                        <li>
                          Tu patrocinio NO incluye el PROAM. El costo adicional
                          deberá ser cubierto de forma independiente.
                        </li>
                      </p>
                    ) : (
                      proamData.proamCourtesy &&
                      formik.values.playerOneProam && (
                        <p>
                          <li>Eres invitado de cortesía al Pro-Am.</li>
                        </p>
                      )
                    )}
                  </Grid>
                )}

                <Grid item xs={12} sm={12} md={12}>
                  <p>Información personal</p>
                  <br />
                </Grid>

                <Grid item xs={4} sm={4} md={6}>
                  <TextField
                    required
                    id="name"
                    type="text"
                    title="Nombres"
                    placeholder="Nombres"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={6}>
                  <TextField
                    required
                    id="lastname"
                    type="text"
                    title="Apellidos"
                    placeholder="Apellidos"
                    value={formik.values.lastname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.lastname && Boolean(formik.errors.lastname)
                    }
                    helperText={
                      formik.touched.lastname && formik.errors.lastname
                    }
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={6}>
                  <TextField
                    required
                    id="email"
                    type="email"
                    title="Email"
                    placeholder="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={6}>
                  <Select
                    required
                    id="sex"
                    title="Sexo"
                    data={[
                      { label: "Hombre", value: 1 },
                      { label: "Mujer", value: 2 },
                    ]}
                    value={formik.values.sex}
                    onChange={formik.handleChange}
                    error={formik.touched.sex && Boolean(formik.errors.sex)}
                    helperText={formik.touched.sex && formik.errors.sex}
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={6}>
                  <RadioButtonGroup
                    required
                    row
                    id="documentType"
                    title="Tipo de documento"
                    options={[
                      { label: "Cédula", value: 1 },
                      { label: "Pasaporte", value: 2 },
                    ]}
                    value={formik.values.documentType}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.documentType &&
                      Boolean(formik.errors.documentType)
                    }
                    helperText={
                      formik.touched.documentType && formik.errors.documentType
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={6}>
                  <MaskTextField
                    required
                    id="documentNumber"
                    type="text"
                    maskType={
                      formik.values.documentType == "1" ? "cedula" : "passport"
                    }
                    title="Documento"
                    placeholder="Documento"
                    value={formik.values.documentNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.documentNumber &&
                      Boolean(formik.errors.documentNumber)
                    }
                    helperText={
                      formik.touched.documentNumber &&
                      formik.errors.documentNumber
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    id="company"
                    type="text"
                    title="Empresa en que trabaja"
                    placeholder="Empresa en que trabaja"
                    value={formik.values.company}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.company && Boolean(formik.errors.company)
                    }
                    helperText={formik.touched.company && formik.errors.company}
                  />
                </Grid>
                {/* TODO: CORREGIR TEXTOS */}
                <Grid item xs={4} sm={4} md={6}>
                  <TextField
                    required
                    id="mobileNumber"
                    type="tel"
                    title="Celular"
                    placeholder="Celular"
                    value={formik.values.mobileNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.mobileNumber &&
                      Boolean(formik.errors.mobileNumber)
                    }
                    helperText={
                      formik.touched.mobileNumber && formik.errors.mobileNumber
                    }
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={6}>
                  <TextField
                    id="phoneNumber"
                    type="tel"
                    title="Teléfono fijo"
                    placeholder="Teléfono fijo"
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.phoneNumber &&
                      Boolean(formik.errors.phoneNumber)
                    }
                    helperText={
                      formik.touched.phoneNumber && formik.errors.phoneNumber
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <p>Datos del jugador</p>
                  <br />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Select
                    required
                    id="tshirtSize"
                    title="Talla de T-shirt"
                    data={[
                      { label: "S", value: 1 },
                      { label: "M", value: 2 },
                      { label: "L", value: 3 },
                      { label: "XL", value: 4 },
                      { label: "XXL", value: 5 },
                    ]}
                    value={formik.values.tshirtSize}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.tshirtSize &&
                      Boolean(formik.errors.tshirtSize)
                    }
                    helperText={
                      formik.touched.tshirtSize && formik.errors.tshirtSize
                    }
                  />
                </Grid>
                {/* TODO: ONLY DECIMAL */}
                <Grid item xs={12} sm={4} md={6}>
                  <TextField
                    required
                    id="handicap"
                    type="number"
                    title="Handicap"
                    placeholder="Handicap"
                    value={formik.values.handicap}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.handicap && Boolean(formik.errors.handicap)
                    }
                    helperText={
                      formik.touched.handicap && formik.errors.handicap
                    }
                  />
                </Grid>
                {/* TODO: ONLY ENTEROS */}
                <Grid item xs={12} sm={4} md={6}>
                  <TextField
                    required
                    id="ghin"
                    type="number"
                    title="GHIN"
                    placeholder="GHIN"
                    value={formik.values.ghin}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.ghin && Boolean(formik.errors.ghin)}
                    helperText={formik.touched.ghin && formik.errors.ghin}
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={6}>
                  <Select
                    required
                    id="gloveSize"
                    title="Talla de Guantilla"
                    data={[
                      { label: "S", value: 1 },
                      { label: "M", value: 2 },
                      { label: "L", value: 3 },
                      { label: "XL", value: 4 },
                    ]}
                    value={formik.values.gloveSize}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.gloveSize &&
                      Boolean(formik.errors.gloveSize)
                    }
                    helperText={
                      formik.touched.gloveSize && formik.errors.gloveSize
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={6}>
                  <RadioButtonGroup
                    required
                    row
                    id="diestro"
                    title="Mano dominante"
                    options={[
                      { label: "Derecho", value: 1 },
                      { label: "Zurdo", value: 2 },
                    ]}
                    value={formik.values.diestro}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.diestro && Boolean(formik.errors.diestro)
                    }
                    helperText={
                      formik.touched.documentType && formik.errors.documentType
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <p>Información del acompañante</p>
                  <br />
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <RadioButtonGroup
                    required
                    row
                    id="guest"
                    title="Incluir acompañante"
                    options={[
                      { label: "No", value: 0 },
                      { label: "Si", value: 1 },
                    ]}
                    value={formik.values.guest}
                    onChange={formik.handleChange}
                    error={formik.touched.guest && Boolean(formik.errors.guest)}
                    helperText={formik.touched.guest && formik.errors.guest}
                  />
                </Grid>
                <CheckRender allowed={formik.values.guest === "1"}>
                  <Grid item xs={4} sm={4} md={6}>
                    <TextField
                      required
                      id="guestName"
                      type="text"
                      title="Nombres"
                      placeholder="Nombres"
                      value={formik.values.guestName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.guestName &&
                        Boolean(formik.errors.guestName)
                      }
                      helperText={
                        formik.touched.guestName && formik.errors.guestName
                      }
                    />
                  </Grid>

                  <Grid item xs={4} sm={4} md={6}>
                    <TextField
                      required
                      id="guestLastName"
                      type="text"
                      title="Apellidos"
                      placeholder="Apellidos"
                      value={formik.values.guestLastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.guestLastName &&
                        Boolean(formik.errors.guestLastName)
                      }
                      helperText={
                        formik.touched.guestLastName &&
                        formik.errors.guestLastName
                      }
                    />
                  </Grid>

                  <Grid item xs={4} sm={4} md={6}>
                    <RadioButtonGroup
                      required
                      row
                      id="guestDocumentType"
                      title="Tipo de documento"
                      options={[
                        { label: "Cédula", value: 1 },
                        { label: "Pasaporte", value: 2 },
                      ]}
                      value={formik.values.guestDocumentType}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.guestDocumentType &&
                        Boolean(formik.errors.guestDocumentType)
                      }
                      helperText={
                        formik.touched.guestDocumentType &&
                        formik.errors.guestDocumentType
                      }
                    />
                  </Grid>

                  <Grid item xs={4} sm={4} md={6}>
                    <MaskTextField
                      required
                      maskType={
                        formik.values.guestDocumentType == "1"
                          ? "cedula"
                          : "passport"
                      }
                      id="guestDocument"
                      type="text"
                      title="Documento"
                      placeholder="Documento"
                      value={formik.values.guestDocument}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.guestDocument &&
                        Boolean(formik.errors.guestDocument)
                      }
                      helperText={
                        formik.touched.guestDocument &&
                        formik.errors.guestDocument
                      }
                    />
                  </Grid>

                  <Grid item xs={4} sm={4} md={6}>
                    <TextField
                      required
                      id="guestEmail"
                      type="email"
                      title="Email"
                      placeholder="Email"
                      value={formik.values.guestEmail}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.guestEmail &&
                        Boolean(formik.errors.guestEmail)
                      }
                      helperText={
                        formik.touched.guestEmail && formik.errors.guestEmail
                      }
                    />
                  </Grid>
                </CheckRender>
              </Fragment>
            </Grid>
            <Grid
              container
              alignItems="flex-end"
              direction="row"
              justifyContent={"end"}
              spacing={{ xs: 1, md: 1.5 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={4} sm={8} md={3}>
                <StyledButton
                  disabled={!formAvailable}
                  onClick={() => formik.handleSubmit()}
                  variant="contained"
                >
                  Registrar
                </StyledButton>
              </Grid>
            </Grid>
            <br />
          </CheckRender>
        </FormContainer>
      </RightContainer>
    </Container>
  );
}

interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.signin.user,
});

const mapDispatchToProps = {
  showGlobalLoading: GlobalLoadingActions.showGlobalLoading,
  hideGlobalLoading: GlobalLoadingActions.hideGlobalLoading,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(RegisterSolo);
